export const Trash = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 20 21" {...props}>
    <path
      d="M15 4.5H20V6.5H18V19.5C18 20.0523 17.5523 20.5 17 20.5H3C2.44772 20.5 2 20.0523 2 19.5V6.5H0V4.5H5V1.5C5 0.94772 5.44772 0.5 6 0.5H14C14.5523 0.5 15 0.94772 15 1.5V4.5ZM16 6.5H4V18.5H16V6.5ZM7 9.5H9V15.5H7V9.5ZM11 9.5H13V15.5H11V9.5ZM7 2.5V4.5H13V2.5H7Z"
      fill="currentColor"
    />
  </svg>
);
